const WEEKDAYS = Object.freeze([
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
])

const LEVELS = Object.freeze([
  Object.freeze({
    id: "nido",
    metadataKey: "nidoMontessori",
    pathname: "/nido-montessori/",
    name: "Nido Montessori",
    aliases: Object.freeze(["Nido", "Nido (Maternal)"]),
    heading: "Nido Montessori en San Pedro de los Pinos",
    metaDescription:
      "Conoce Nido Montessori para bebés de 2 meses a 1 año en San Pedro de los Pinos: campus, horario e información de admisiones.",
    description:
      "Nido Montessori acompaña a bebés de 2 meses a 1 año mediante el movimiento, el juego y la exploración en un ambiente preparado, seguro y estimulante.",
    age: "2 meses a 1 año",
    campusId: "calle-9",
    schedule: "Lunes a viernes, 09:00–13:30",
    dayOfWeek: WEEKDAYS,
    programType: "Nido Montessori",
    imageKey: "nido",
    image: "/og/nido-montessori.jpg",
    imageAlt:
      "Bebé acompañado por una persona adulta, imagen ilustrativa de Nido Montessori",
    theme: "blue",
    admissionsMessage:
      "Hola, quiero solicitar informes de admisiones para Nido Montessori (2 meses a 1 año).",
    faqs: Object.freeze([
      Object.freeze({
        question: "¿Qué edades atiende Nido Montessori?",
        answer: "Nido Montessori atiende a bebés de 2 meses a 1 año.",
      }),
      Object.freeze({
        question: "¿En qué campus se ofrece Nido Montessori?",
        answer:
          "Nido Montessori se ofrece en Calle 9 No. 113, Col. San Pedro de los Pinos, Alcaldía Benito Juárez, Ciudad de México.",
      }),
      Object.freeze({
        question: "¿Cuál es el horario de Nido Montessori?",
        answer:
          "El horario escolar de Nido Montessori es de lunes a viernes, de 09:00 a 13:30.",
      }),
      Object.freeze({
        question: "¿Cómo solicito información de admisiones para Nido?",
        answer:
          "Consulta los costos vigentes en la sección de inversión educativa y solicita informes de admisiones por WhatsApp.",
      }),
    ]),
  }),
  Object.freeze({
    id: "comunidad-infantil",
    metadataKey: "comunidadInfantilMontessori",
    pathname: "/comunidad-infantil-montessori/",
    name: "Comunidad Infantil Montessori",
    aliases: Object.freeze(["Comunidad Infantil", "Maternal"]),
    heading: "Comunidad Infantil Montessori en San Pedro de los Pinos",
    metaDescription:
      "Conoce Comunidad Infantil Montessori para niñas y niños de 1 a 3 años en San Pedro de los Pinos: campus, horario y admisiones.",
    description:
      "Comunidad Infantil Montessori acompaña a niñas y niños de 1 a 3 años en la práctica de habilidades cotidianas, la exploración, la creatividad y la imaginación.",
    age: "1 a 3 años",
    campusId: "calle-9",
    schedule: "Lunes a viernes, 09:00–13:30",
    dayOfWeek: WEEKDAYS,
    programType: "Comunidad Infantil Montessori",
    imageKey: "comunidad-infantil",
    image: "/og/comunidad-infantil-montessori.jpg",
    imageAlt:
      "Niña pequeña explorando, imagen ilustrativa de Comunidad Infantil Montessori",
    theme: "orange",
    admissionsMessage:
      "Hola, quiero solicitar informes de admisiones para Comunidad Infantil Montessori (1 a 3 años).",
    faqs: Object.freeze([
      Object.freeze({
        question: "¿Qué edades atiende Comunidad Infantil Montessori?",
        answer:
          "Comunidad Infantil Montessori atiende a niñas y niños de 1 a 3 años.",
      }),
      Object.freeze({
        question: "¿En qué campus se ofrece Comunidad Infantil Montessori?",
        answer:
          "Comunidad Infantil Montessori se ofrece en Calle 9 No. 113, Col. San Pedro de los Pinos, Alcaldía Benito Juárez, Ciudad de México.",
      }),
      Object.freeze({
        question: "¿Cuál es el horario de Comunidad Infantil Montessori?",
        answer:
          "El horario escolar de Comunidad Infantil Montessori es de lunes a viernes, de 09:00 a 13:30.",
      }),
      Object.freeze({
        question:
          "¿Cómo solicito información de admisiones para Comunidad Infantil?",
        answer:
          "Consulta los costos vigentes en la sección de inversión educativa y solicita informes de admisiones por WhatsApp.",
      }),
    ]),
  }),
  Object.freeze({
    id: "casa-de-ninos",
    metadataKey: "casaDeNinosMontessori",
    pathname: "/casa-de-ninos-montessori/",
    name: "Casa de Niños Montessori",
    aliases: Object.freeze(["Casa de Niños", "Preescolar"]),
    heading: "Casa de Niños Montessori en San Pedro de los Pinos",
    metaDescription:
      "Conoce Casa de Niños Montessori para niñas y niños de 3 a 6 años en San Pedro de los Pinos: campus, horario y admisiones.",
    description:
      "Casa de Niños Montessori acompaña a niñas y niños de 3 a 6 años mediante proyectos de investigación, trabajo en equipo y oportunidades de expresión física y artística.",
    age: "3 a 6 años",
    campusId: "calle-9",
    schedule: "Lunes a viernes, 09:00–13:30",
    dayOfWeek: WEEKDAYS,
    programType: "Casa de Niños Montessori (Preescolar)",
    imageKey: "casa-de-ninos",
    image: "/og/casa-de-ninos-montessori.jpg",
    imageAlt:
      "Niños en un ambiente educativo, imagen ilustrativa de Casa de Niños Montessori",
    theme: "yellow",
    admissionsMessage:
      "Hola, quiero solicitar informes de admisiones para Casa de Niños Montessori (3 a 6 años).",
    faqs: Object.freeze([
      Object.freeze({
        question: "¿Qué edades atiende Casa de Niños Montessori?",
        answer:
          "Casa de Niños Montessori atiende a niñas y niños de 3 a 6 años.",
      }),
      Object.freeze({
        question: "¿En qué campus se ofrece Casa de Niños Montessori?",
        answer:
          "Casa de Niños Montessori se ofrece en Calle 9 No. 113, Col. San Pedro de los Pinos, Alcaldía Benito Juárez, Ciudad de México.",
      }),
      Object.freeze({
        question: "¿Cuál es el horario de Casa de Niños Montessori?",
        answer:
          "El horario escolar de Casa de Niños Montessori es de lunes a viernes, de 09:00 a 13:30.",
      }),
      Object.freeze({
        question:
          "¿Cómo solicito información de admisiones para Casa de Niños?",
        answer:
          "Consulta los costos vigentes en la sección de inversión educativa y solicita informes de admisiones por WhatsApp.",
      }),
    ]),
  }),
  Object.freeze({
    id: "primaria",
    metadataKey: "primariaMontessori",
    pathname: "/primaria-montessori/",
    name: "Primaria Montessori (Taller)",
    aliases: Object.freeze(["Taller", "Taller 1 y 2", "Primaria"]),
    heading: "Primaria Montessori en San Pedro de los Pinos, CDMX",
    metaDescription:
      "Primaria Montessori en CDMX, Benito Juárez, para niñas y niños de 6 a 12 años. Incorporada a la SEP. Conoce horarios, costos y admisiones en Kalpilli.",
    description:
      "Primaria Montessori (Taller) acompaña a niñas y niños de 6 a 12 años en la exploración de ciencias, historia y literatura, así como en el desarrollo del liderazgo y el trabajo en equipo.",
    age: "6 a 12 años",
    campusId: "av-dos",
    schedule: "Lunes a viernes, 08:00–14:00",
    dayOfWeek: WEEKDAYS,
    programType: "Primaria Montessori (Taller)",
    credential: "Primaria incorporada a la SEP, CCT 09PPR0263C",
    imageKey: "primaria",
    image: "/og/primaria-montessori.webp",
    imageAlt:
      "Estudiantes realizando una actividad, imagen ilustrativa de Primaria Montessori",
    heroImageAlt: "Ambiente Montessori preparado con mesas y materiales",
    theme: "red",
    admissionsMessage:
      "Hola, quiero solicitar informes de admisiones para Primaria Montessori (6 a 12 años).",
    faqs: Object.freeze([
      Object.freeze({
        question: "¿Qué edades atiende Primaria Montessori?",
        answer:
          "Primaria Montessori (Taller) atiende a niñas y niños de 6 a 12 años.",
      }),
      Object.freeze({
        question: "¿En qué campus se ofrece Primaria Montessori?",
        answer:
          "Primaria Montessori (Taller) se ofrece en Avenida Dos 48, Col. San Pedro de los Pinos, Alcaldía Benito Juárez, Ciudad de México, CP 03800.",
      }),
      Object.freeze({
        question: "¿Cuál es el horario de Primaria Montessori?",
        answer:
          "El horario escolar de Primaria Montessori es de lunes a viernes, de 08:00 a 14:00.",
      }),
      Object.freeze({
        question: "¿La Primaria Montessori está incorporada a la SEP?",
        answer:
          "Sí. Primaria Montessori (Taller) está incorporada a la SEP con la Clave de Centro de Trabajo 09PPR0263C.",
      }),
      Object.freeze({
        question: "¿Dónde puedo consultar las colegiaturas de primaria?",
        answer:
          "Los costos vigentes se publican en la sección de inversión educativa de Inscripciones. Antes de iniciar el proceso, confirma con admisiones los conceptos incluidos, la disponibilidad y las condiciones aplicables al ciclo escolar.",
      }),
      Object.freeze({
        question: "¿Qué significa Taller en una primaria Montessori?",
        answer:
          "Taller es el nombre del nivel de primaria Montessori. En Kalpilli atiende a niñas y niños de 6 a 12 años, con exploración de ciencias, historia y literatura, trabajo en equipo y acompañamiento de las guías.",
      }),
      Object.freeze({
        question: "¿Cómo solicito información de admisiones para Primaria?",
        answer:
          "Consulta los costos vigentes en la sección de inversión educativa y solicita informes de admisiones por WhatsApp.",
      }),
    ]),
  }),
])

const LEVELS_BY_ID = Object.freeze(
  Object.fromEntries(LEVELS.map(level => [level.id, level]))
)

module.exports = {
  LEVELS,
  LEVELS_BY_ID,
}
